<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica difficoltà' : 'Nuova difficoltà'"
                     @back="$router.replace('/difficulties')" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Nome*"
              v-model="editingItem.name.it"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Abbreviato*"
              v-model="editingItem.abbrev.it"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Valore*"
              v-model="editingItem.value"
              :rules="[rules.required, rules.minInt(0)]"
              type="number"
              step="1"
              min="0"
          ></v-text-field>
        </v-col>



        <form-footer @back="$router.replace('/difficulties')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type { Difficulty } from "@/models.ts";
export default {
  components: {FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)

    const editingItem = ref<Difficulty>({
      value: 0,
      abbrev: {it:''},
      desc: {it:''},
      name: {it:''}
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<Difficulty>('difficulties', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/difficulties')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      form,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      rules,
      formatDate : utils.formatDate,
      async save(goBackAfterSave:boolean) {
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<Difficulty>('difficulties', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("difficoltà salvata")
        if(goBackAfterSave) {
          await router.replace('/difficulties')
        } else if(route.params.id === 'new'){
          await router.replace(`/difficulties/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
